module.exports = __webpack_public_path__ + "img/New York outline.8d8d9ebf.png";